module.exports = __webpack_public_path__ + "static/img/yinhang.b59b4d77.png";